import { render, staticRenderFns } from "./SalesForMemberships.vue?vue&type=template&id=22b21234"
import script from "./SalesForMemberships.vue?vue&type=script&lang=js"
export * from "./SalesForMemberships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports